import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  description?: string;
  icon?: string;
  action?: ReactNode;
  id?: string;
}

export default function SectionHeading({ title, description, icon, action, id }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
      <div className="min-w-0">
        <h2 id={id} className="flex items-center gap-2.5 font-heading font-semibold text-xl md:text-2xl text-foreground-950">
          {icon && (
            <span className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
              <i className={`${icon} text-lg`}></i>
            </span>
          )}
          <span className="truncate">{title}</span>
        </h2>
        {description && (
          <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}